import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatUrl'
})
export class FormatUrlPipe implements PipeTransform {
  transform(url: string): string {
    if (!url) {
      return url;
    }
    // If the URL already has a protocol, return it unchanged.
    if (url.startsWith('http://') || url.startsWith('https://')) {
      return url;
    }
    // Otherwise, prepend "http://"
    return 'http://' + url;
  }
}
